import React, { useState, useEffect } from "react";
import "../styles/Home.css"; // Reutilizando estilos se necessário
import Navbar from "../components/Navbar";
import BannerCarousel from "../components/BannerCarousel";
import { Contact } from "../components/Contact";
import Footer from "../components/Footer";
import AnimatedElement from "../components/AnimatedElement";
import { useTranslation } from "react-i18next";

const missaoImg = process.env.PUBLIC_URL + "/assets/img/banners/missao.png";
const empresaImg = process.env.PUBLIC_URL + "/assets/img/banners/empresa.PNG";

export default function Sobre() {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeAccordion, setActiveAccordion] = useState(null);

  const tabs = [
    {
      year: "2021",
      text: t("about.history.tabs.2021"),
    },
    {
      year: "2022",
      text: t("about.history.tabs.2022"),
    },
    {
      year: "2023",
      text: t("about.history.tabs.2023"),
    },
    {
      year: "2024",
      text: t("about.history.tabs.2024", { returnObjects: true }),
    },
    {
      year: "2025",
      text: t("about.history.tabs.2025", { returnObjects: true }),
    },
    {
      year: "2026",
      text: t("about.history.tabs.2026", { returnObjects: true }),
    },
  ];

  // Cada item de "text" pode ser uma string simples ou um objeto
  // { text, subItems: [{ label, text }] } para blocos com sublista.
  const renderHistoryText = (text) => {
    const items = Array.isArray(text) ? text : [text];
    return items.map((item, idx) =>
      typeof item === "string" ? (
        <p key={idx}>{item}</p>
      ) : (
        <div key={idx}>
          <p>{item.text}</p>
          {item.subItems && (
            <ul className="tab-content-list">
              {item.subItems.map((sub, subIdx) => (
                <li key={subIdx}>
                  <strong>{sub.label}:</strong> {sub.text}
                </li>
              ))}
            </ul>
          )}
        </div>
      )
    );
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  let banner = [
    {
      title: "",
      subtitle: t("about.banner.subtitle"),
      description: t("about.banner.description"),
      image: "/assets/img/banners/banner-geral.png",
      buttonText: t("about.banner.buttonText"),
    },
  ];

  return (
    <div className="sobre">
      <Navbar />
      <div id="banner-sobre">
        <BannerCarousel banners={banner} />
      </div>
      {/* Missão */}
      <section id="nossa-missao" className="sobre-section">
        <div className="container">
          <div className="sobre-content">
            <AnimatedElement animation="fade-right" className="sobre-image">
              <img src={missaoImg} alt="Missão Dsiacdata" />
            </AnimatedElement>
            <AnimatedElement animation="fade-left" className="sobre-text">
              <h2>{t("about.mission.title")}</h2>
              <p>{t("about.mission.text")}</p>
            </AnimatedElement>
          </div>
        </div>
      </section>

      {/* Nossa empresa */}
      <section className="sobre-section empresa-section">
        <div className="container">
          <div className="sobre-content">
            <AnimatedElement animation="fade-right" className="sobre-text">
              <h2>{t("about.company.title")}</h2>
              <p>{t("about.company.text")}</p>
            </AnimatedElement>
            <AnimatedElement animation="fade-left" className="sobre-image">
              <img src={empresaImg} alt="Equipe Dsiacdata" />
            </AnimatedElement>
          </div>
        </div>
      </section>

      {/* Tabs de anos */}
      <section id="nossa-historia" className="sobre-section">
        <div className="container">
          <AnimatedElement animation="fade-up">
            <div
              className="sobre-header"
              style={{ marginBottom: 50, animation: "fadeInUp 0.8s ease-out" }}
            >
              <h2
                style={{
                  fontSize: "2.8rem",
                  fontWeight: 700,
                  color: "#2c3e50",
                  marginBottom: 0,
                  position: "relative",
                }}
              >
                {t("about.history.title")}
              </h2>
              <p
                style={{
                  fontSize: "1.2rem",
                  color: "#666",
                  maxWidth: 600,
                  lineHeight: 1.6,
                }}
              >
                {t("about.history.subtitle")}
              </p>
            </div>
            <div className="sobre-tabs-card">
              {isMobile ? (
                <div className="faq-container">
                  {tabs.map((tab, idx) => (
                    <div
                      key={tab.year}
                      className={`faq-item ${
                        activeAccordion === idx ? "active" : ""
                      }`}
                    >
                      <div
                        className="faq-question"
                        onClick={() =>
                          setActiveAccordion(
                            activeAccordion === idx ? null : idx
                          )
                        }
                      >
                        <h4>{tab.year}</h4>
                        <div className="faq-icon">
                          <span
                            className={`faq-arrow ${
                              activeAccordion === idx ? "rotated" : ""
                            }`}
                          >
                            ▼
                          </span>
                        </div>
                      </div>
                      <div
                        className={`faq-answer ${
                          activeAccordion === idx ? "expanded" : ""
                        }`}
                      >
                        <div className="faq-answer-content">
                          {renderHistoryText(tab.text)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  <div className="sobre-tabs">
                    {tabs.map((tab, idx) => (
                      <div
                        key={tab.year}
                        className={`sobre-tab-item${
                          selectedTab === idx ? " active" : ""
                        }`}
                        onClick={() => setSelectedTab(idx)}
                      >
                        <h3>{tab.year}</h3>
                      </div>
                    ))}
                  </div>
                  <div className="sobre-tab-content">
                    <div className="sobre-tab-content-inner">
                      {renderHistoryText(tabs[selectedTab].text)}
                    </div>
                  </div>
                </>
              )}
            </div>
          </AnimatedElement>
        </div>
      </section>

      <Contact />
      <Footer />
    </div>
  );
}
